// Pure state machine for an edit buffer. No DOM, no React, no IO.
// Consumed by DocPane's editMode wiring and by edit-buffer.test.js.
// Attached to window.mindexEditBuffer by vendor.entry.js so app.jsx
// can call `const { createEditBuffer } = window.mindexEditBuffer;`.

export function createEditBuffer({ baseText, baseSha256 }) {
  let _baseText = baseText == null ? '' : baseText;
  let _baseSha = baseSha256;
  let _current = _baseText;

  const isDirty = () => _current !== _baseText;

  return {
    isDirty,
    getState: () => ({
      currentText: _current,
      baseText: _baseText,
      baseSha256: _baseSha,
      isDirty: isDirty(),
    }),
    applyEdit: (next) => {
      _current = next == null ? '' : String(next);
    },
    markSaved: ({ text, sha256 }) => {
      _baseText = text == null ? '' : text;
      _baseSha = sha256;
      _current = _baseText;
    },
    revertToBase: () => {
      _current = _baseText;
    },
  };
}
